import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import { DpSuccessMessageComponent } from '../../common-component/dp-success-message/dp-success-message.component';
import { RequestMapper } from '../../request-mapper';
import { AuthTransmissionService } from '../../services/raintree/Transmission/auth-transmission.service';
import { RaintreeResponse } from '../../services/raintree/interfaces/raintree-response';
import { SnackbarService } from '../../services/common/snackbar.service';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, RouterModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
})
export class ResetPasswordComponent implements OnInit {
  signupForm!: FormGroup;
  verificationForm!: FormGroup;
  newPasswordForm!: FormGroup;
  resetSessionId: any
  currentForm = 1;
  forceResetOtp = new FormControl(null, [Validators.required, Validators.pattern(/^\d{6}$/)])
  mobNumber: any
  phoneNumberInvalid = false;
  emailInvalid = false;
  phoneOtpInvalid = false;
  emailOtpInvalid = false;
  passwordVisible = false;
  reEnterPasswordVisible = false;
  passwordInvalid = false;
  specialChars = `@#$%^&*()_+-=[]{}:.,?~|<>`;
  pwdvalidation: any = {
    lengthCheck: false,
    characterCheck: false,
    consecutiveValueCheck: false,
    nameCheck: false,
    emailCheck: false
  }
  visibilityOnIcon: string = '--pass-visibility-on';
  visibilityOffIcon: string = '--pass-visibility-off';
  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private _router: Router,
    private _authTransmissionService: AuthTransmissionService,
    private snackbar: SnackbarService
  ) { }
  //
  navEntries: any
  ngOnInit() {
    const pwd = localStorage.getItem('loginPwd')

    this.mobNumber = localStorage.getItem('forceResetMob')
    this.resetSessionId = localStorage.getItem('resetSessionId')
    if (this.resetSessionId) {
      this.startCountdownForMobile()
      this.currentForm = 2
    }
    if (localStorage.getItem('refresh') && this.currentForm == 2) {
      localStorage.clear()
      this._router.navigate(['/login']);
    } else {
      localStorage.setItem('refresh', 'true');
    }

    this.signupForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });

    this.verificationForm = this.fb.group({
      emailOtp: ['', Validators.required],
    });

    this.newPasswordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(8)]],
      reEnterPassword: ['', [Validators.required, Validators.minLength(8)]],
    });
    this.newPasswordForm.get('password')?.valueChanges.subscribe((item: any) => {
      if (item && item?.length > 0)
        this.checkPasswordValidation(item)
      else {
        this.passwordInvalid = true
        Object.keys(this.pwdvalidation).forEach(key => {
          this.pwdvalidation[key as keyof typeof this.pwdvalidation] = false;
        });
      }
    })
    // this.showPopup = false;
  }

  onInputBlur(field: string) {
    if (field === 'phoneNumber') {
      this.phoneNumberInvalid = this.signupForm.controls['phoneNumber'].invalid;
    }
    if (field === 'email') {
      this.emailInvalid = this.signupForm.controls['email'].invalid;
    }
    if (field === 'forceResetOtp') {
      console.log(field)
      this.phoneOtpInvalid = this.forceResetOtp.invalid;
    }
    if (field === 'emailOtp') {
      this.emailOtpInvalid = this.verificationForm.controls['emailOtp'].invalid;
    }
    if (field === 'password') {
      const values = Object.values(this.pwdvalidation)
      if (values.includes(false))
        this.passwordInvalid = true
      else
        this.passwordInvalid = false
    }
  }
  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }
  toggleReEnterPasswordVisibility() {
    this.reEnterPasswordVisible = !this.reEnterPasswordVisible;
  }
  async checkPasswordValidation(password: string) {
    // const strongPwdRegex = /^(?!.(?:'|"|;|\\|\/|`))(?!.--)(?=.\d)(?=.[a-z])(?=.[A-Z])[A-Za-z\d@#$%^&()_+\-=\[\]{}:.,?~|<>]{10,15}$/;
    const firstName = localStorage.getItem('firstName') ? localStorage.getItem('firstName')!?.toLowerCase() : ' '
    const lastName = localStorage.getItem('lastName') ? localStorage.getItem('lastName')!?.toLowerCase() : ' '
    let emailVal = localStorage.getItem('loginEmail') ?? this.signupForm.get('email')?.value
    emailVal = emailVal.toLowerCase()
    this.pwdvalidation.nameCheck = !password.toLowerCase().includes(firstName) && !password.toLowerCase().includes(lastName) &&
      !password.toLowerCase().includes('satsang')
    const strongPwdRegex = /^(?!.*(?:'|"|;|\\|\/|`))(?!.*--)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&*()_+\-=\[\]{}:.,?~|<>])[A-Za-z\d@#$%^&*()_+\-=\[\]{}:.,?~|<>]{8,15}$/;
    const valid = strongPwdRegex.test(password);
    // this.pwdvalidation.nameCheck = valid
    this.pwdvalidation.characterCheck = valid;
    // this.pwdvalidation.emailCheck = !password.toLowerCase().includes(emailVal.toLowerCase())
    const containsEmailPart = emailVal.includes(password.toLowerCase());
    this.pwdvalidation.emailCheck = !(containsEmailPart && password.length <= 15);
    if (password.length >= 8 && password.length <= 15)
      this.pwdvalidation.lengthCheck = true
    else
      this.pwdvalidation.lengthCheck = false;
    this.pwdvalidation.consecutiveValueCheck = await this.hasConsecutiveSequence(password)
  }
  async hasConsecutiveSequence(str: string): Promise<boolean> {
    const s = str.toLowerCase(); // make case-insensitive
    const n = s.length;

    for (let i = 0; i < n - 2; i++) {
      // Check if it's a numeric sequence
      if (
        this.isDigit(s[i]) &&
        this.isDigit(s[i + 1]) &&
        this.isDigit(s[i + 2]) &&
        s.charCodeAt(i + 1) === s.charCodeAt(i) + 1 &&
        s.charCodeAt(i + 2) === s.charCodeAt(i) + 2
      ) {
        return false;
      }

      // Check if it's an alphabet sequence
      if (
        this.isLetter(s[i]) &&
        this.isLetter(s[i + 1]) &&
        this.isLetter(s[i + 2]) &&
        s.charCodeAt(i + 1) === s.charCodeAt(i) + 1 &&
        s.charCodeAt(i + 2) === s.charCodeAt(i) + 2
      ) {
        return false;
      }
    }
    for (let i = n; i > n - 2; i--) {
      if (
        this.isDigit(s[i]) &&
        this.isDigit(s[i - 1]) &&
        this.isDigit(s[i - 2]) &&
        s.charCodeAt(i - 1) === s.charCodeAt(i) + 1 &&
        s.charCodeAt(i - 2) === s.charCodeAt(i) + 2
      ) {
        return false;
      }
      if (
        this.isLetter(s[i]) &&
        this.isLetter(s[i - 1]) &&
        this.isLetter(s[i - 2]) &&
        s.charCodeAt(i - 1) === s.charCodeAt(i) + 1 &&
        s.charCodeAt(i - 2) === s.charCodeAt(i) + 2
      ) {
        return false;
      }
    }
    return true;
  }

  private isDigit(ch: string): boolean {
    return ch >= "0" && ch <= "9";
  }

  private isLetter(ch: string): boolean {
    return ch >= "a" && ch <= "z";
  }


  restrictContactInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;
    const pattern = /[0-9]/;

    // Allowed keys (e.g., Backspace, Delete, Arrow keys, etc.)
    const allowedKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Tab',
      'Escape',
      'Enter',
    ];

    // Allow key combinations with Ctrl, Alt, or Meta keys
    if (
      allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }

    if (!pattern.test(input) || limit.value.length >= 6) {
      event.preventDefault();
      return;
    }

    // if (limit.value.length === 0 && !/[6-9]/.test(input)) {
    //   event.preventDefault();
    // }
  }

  onSubmit() {
    let currentFormGroup: FormGroup = this.fb.group({});

    if (this.currentForm == 1) {
      currentFormGroup = this.signupForm;
    } else if (this.currentForm == 2) {
      currentFormGroup = this.verificationForm;
    } else if (this.currentForm == 3) {
      currentFormGroup = this.newPasswordForm;
    }

    // if (currentFormGroup.valid) {
    //   // if (this.currentForm < 3) {
    //   //   this.currentForm++;
    //   //   console.log(this.currentForm);
    //   // }
    //   if (this.currentForm == 1 && !this.firstStepError) {
    //     this.currentForm++;
    //   } else if (this.currentForm == 2 && !this.secondStepError ) {
    //     this.currentForm++;
    //   } else if (this.currentForm == 3 ) {
    //     this.currentForm++;
    //   } else {
    //     const payload = {
    //       ...this.signupForm.value,
    //       ...this.verificationForm.value,
    //     };

    //     // Instead of making an API call, we'll just log the payload.
    //     console.log('API payload:', payload);
    //     //this.openDialog();
    //     currentFormGroup.reset();
    //   }
    // } else {
    //   console.log('Invalid');
    // }
    /////////////////////////////////////////
    if (currentFormGroup.valid) {
      if (this.currentForm === 1) {
        this.forgotPasswordSendCodeWithIncrement();
      } else if (this.currentForm === 2) {
        this.forgotPasswordVerifyCode();
      } else if (this.currentForm === 3) {
        this.forgotPasswordRestPassword();
      }
    } else {
      console.log('Invalid form');
    }
  }

  afterSendingCodeSessionId: any;
  firstStepError: boolean = false;
  secondStepError: boolean = false;
  gotResponseInStepOne: boolean = false
  forgotPasswordSendCode() {
    this.startCountdownForMobile();
    let forgotPasswordSendCodePayload = {
      email: this.signupForm.get('email')?.value,
    };
    console.log(forgotPasswordSendCodePayload);
    this._authTransmissionService
      .getForgotPasswordSendCode(forgotPasswordSendCodePayload)
      .subscribe({
        next: (response: any) => {
          console.log(response);
          if (response)
            this.gotResponseInStepOne = true
          console.log(this.gotResponseInStepOne, "inside func")
          this.afterSendingCodeSessionId = response.data.sessionId;
          console.log(this.afterSendingCodeSessionId, 'session id 1');
        },
        error: (error) => {
          console.log(error);
          this.firstStepError = true;
          console.log(this.firstStepError);

          this.snackbar.snackbar(error, 'ok', 'success-snackbar');
        },
      });
  }
  forgotPasswordSendCodeWithIncrement() {

    this.startCountdownForMobile();
    let forgotPasswordSendCodePayload = {
      email: this.signupForm.get('email')?.value,
    };
    console.log(forgotPasswordSendCodePayload);
    this._authTransmissionService
      .getForgotPasswordSendCode(forgotPasswordSendCodePayload)
      .subscribe({
        next: (response: any) => {
          console.log(response);
          this.currentForm++
          console.log(this.gotResponseInStepOne, "inside func")
          this.afterSendingCodeSessionId = response.data.sessionId;
          console.log(this.afterSendingCodeSessionId, 'session id 1');
        },
        error: (error) => {
          console.log(error);
          this.firstStepError = true;
          console.log(this.firstStepError);

          this.snackbar.snackbar(error, 'ok', 'success-snackbar');
        },
      });
  }

  afterVerifyingCodeSessionId: any;
  forgotPasswordVerifyCode() {
    let forgotPasswordSendCodePayload: any = {
    };
    if (!this.phoneOtpInvalid && !this.emailOtpInvalid) {
      if (this.resetSessionId) {
        forgotPasswordSendCodePayload = {
          emailId: localStorage.getItem('loginEmail'),
          forcePwdReset: true,
          verificationCode: this.forceResetOtp?.value,
          sessionId: this.resetSessionId
        }
      } else {
        forgotPasswordSendCodePayload = {
          verificationCode: this.verificationForm.get('emailOtp')?.value,
          sessionId: this.afterSendingCodeSessionId,
        }
      }
      console.log(forgotPasswordSendCodePayload);
      this._authTransmissionService
        .getForgotPasswordVerifyCode(forgotPasswordSendCodePayload)
        .subscribe({
          next: (response: any) => {
            console.log(response);
            this.currentForm++;
            localStorage.setItem('firstName', response.data.firstName)
            localStorage.setItem('lastName', response.data.lastName)
            this.afterVerifyingCodeSessionId = response.data.sessionId;
          },
          error: (error) => {
            console.log(error);
            this.secondStepError = true;
            console.log(this.secondStepError);

            this.snackbar.snackbar(error, 'ok', 'success-snackbar');
          },
        });
    }
  }
  onForceResetOtpVerify() {
    if (!this.phoneOtpInvalid) {

      let forcePasswordSendCodePayload = {
        emailId: localStorage.getItem('loginEmail'),
        forcePwdReset: true,
        verificationCode: this.forceResetOtp?.value,
        sessionId: this.resetSessionId,
      };
      console.log(forcePasswordSendCodePayload);
      this._authTransmissionService
        .getForgotPasswordVerifyCode(forcePasswordSendCodePayload)
        .subscribe({
          next: (response: any) => {
            console.log(response);
            this.currentForm++;
            this.afterVerifyingCodeSessionId = response.data.sessionId;
          },
          error: (error) => {
            console.log(error);
            this.secondStepError = true;
            console.log(this.secondStepError);

            this.snackbar.snackbar(error, 'ok', 'success-snackbar');
          },
        });
    }
  }
  resendForceOtp() {
    const pwd = localStorage.getItem('loginPwd')
    const finalPwd = pwd ? atob(pwd) : null
    let payload = {
      email: localStorage.getItem('loginEmail'),
      password: finalPwd
    }
    this._authTransmissionService.getAuthToken(payload).subscribe({
      next: async (response: RaintreeResponse) => {

        if (response['data'].forcePwdReset) {
          this._router.navigate([RequestMapper.RESET_PASSWORD]);
          localStorage.removeItem('resetSessionId')
          this.resetSessionId = response['data'].sessionId
          localStorage.setItem('resetSessionId', response['data'].sessionId)
          localStorage.setItem('forceResetMob', response['data'].mobileNumber)
        }
        this.startCountdownForMobile();
      },
      error: (error) => {
        this.snackbar.snackbar(error, 'ok', 'success-snackbar');
      },
    });
  }
  forgotPasswordRestPassword() {
    if (this.newPasswordForm.get('password')?.value == this.newPasswordForm.get('reEnterPassword')?.value &&
      !this.passwordInvalid) {
      let forgotPasswordRestPassword: any = {
        sessionId: this.afterVerifyingCodeSessionId,
        confirmPassword: this.newPasswordForm.get('reEnterPassword')?.value,
        newPassword: this.newPasswordForm.get('password')?.value,
      };
      if (this.resetSessionId) {
        forgotPasswordRestPassword = {
          ...forgotPasswordRestPassword,
          forcePwdReset: true,
          emailId: localStorage.getItem('loginEmail'),
        }
      }
      console.log(forgotPasswordRestPassword);
      this._authTransmissionService
        .getForgotPasswordVerifyCode(forgotPasswordRestPassword)
        .subscribe({
          next: (response: any) => {
            console.log(response);

            this.dialog.open(DpSuccessMessageComponent, {
              panelClass: 'common-pannel-dialog-container',
              data: {
                mainHeading: 'Your password has been successfully reset!',
                subHeading: 'You can login to DP using the new credentitals',
                buttonValue: 'Login now',
                routeNavigate: true,
                routerLink: RequestMapper.LOGIN,
              },
            });
          },
          error: (error) => {
            console.log(error);

            this.snackbar.snackbar(error, 'ok', 'success-snackbar');
          },
        });
    }
  }
  restrictEmailInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;
    const pattern = /^[a-zA-Z0-9._@-]+$/;

    const allowedKeys = [
      'Backspace',
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'Delete',
    ];

    if (
      allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }

    // Prevent input if it doesn't match the pattern or exceeds typical email length (optional)
    if (!pattern.test(input)) {
      event.preventDefault();
    }
  }
  openDialog(): void {
    this.dialog.open(DpSuccessMessageComponent, {
      panelClass: 'common-pannel-dialog-container',
      data: {
        mainHeading: 'We’ve successfully reset your password!',
        subHeading: 'Your new credentials are active',
        buttonValue: 'Create new password',
        routeNavigate: true,
        routerLink: RequestMapper.LOGIN,
      },
    });
  }
  isSpanDisabledForMobile = true;
  countdownForMobile = 180;
  countdownIntervalForMobile: any;
  mobilePayload: any;

  onResendForMobile(): void {
    this.resetSessionId ? this.resendForceOtp() : this.forgotPasswordSendCode();
    this.isSpanDisabledForMobile = true;
    this.countdownForMobile = 180; // Reset countdown

  }
  startCountdownForMobile(): void {
    this.countdownIntervalForMobile = setInterval(() => {
      if (this.countdownForMobile > 0) {
        this.countdownForMobile--;
      } else {
        this.isSpanDisabledForMobile = false;
        clearInterval(this.countdownIntervalForMobile);
      }
    }, 1000);

  }
  counter: number = 0;
  allowedKeys: any[] = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'];
  restrictPasswordInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;

    const pattern = /^[a-zA-Z0-9@-_.*]+$/;
    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (!pattern.test(input) || limit.value.length >= 20) {
      event.preventDefault(); // Prevent input if it doesn't match the pattern
    }
  }
  restrictConfirmPasswordInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;

    // const pattern = /^[a-zA-Z0-9@-_.]+$/;
    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (limit.value.length >= 15) {
      event.preventDefault(); // Prevent input if it doesn't match the pattern
    }
  }
}
